module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "prect",
    attrs: {
      "id": "note"
    }
  }, [_c('a', {
    attrs: {
      "id": "pviii"
    }
  }), _c('a', {
    attrs: {
      "id": "pix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005Contents#note-"
    }
  }, [_c('b', [_vm._v("A NOTE FROM "), _c('br'), _vm._v("THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_c('b', [_vm._v("M")])]), _vm._v("y name is Ollie Ollerton. I am a survivor, a former UK Special Forces soldier and, at the time of writing this book, have 51 years of experience on this planet. I have been trained to fight and survive in every known theatre of operations, from jungle to arctic, desert to sea. My purpose in writing this book is to prepare you for various scenarios that could happen to any of us. It’s not rocket science and I don’t consider myself an expert. What I do consider myself to be is a self-aware human who values highly the ability to think in a rational and practical manner, with the knowledge and experience to handle any given situation that I may find myself in. I want to share that knowledge with you as it could very well save your life, or someone else’s for that matter. The last thing anyone wants to die of is ignorance, so well done for taking the first step towards an education you cannot afford not to have.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-230c6b80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006-A_Note_From.vue
// module id = 69
// module chunks = 0